<template>
    <div ref="overviewWrapper"
         :class="overviewClassName"
         class="resource-overview">
        <div class="overview-content">
            <div class="recommend-mask">
                <div class="recommend-left-mask">
                    <div class="total-cates-mask">
                        <div class="block-header">
                            <h5>{{ langTransfer(`${resourceNameMap[resourceType]}分类`) }}
                            <template v-if="isShowResouceCount">
                                ({{resourceCatesTotal}})
                            </template>
                            </h5>
                            <span @click="goAllCatesRoute('all')">
                                {{ langTransfer('全部') }}
                            </span>
                        </div>
                        <div :class="resourceCatesClass">
                            <div v-for="(item,index) in resourceCates"
                                 :key="index"
                                 class="cate-item"
                                 @click="goAllCatesRoute(item)">
                                <p>{{ item.CategoryName }}</p>
                                <span v-if="isShowResouceCount">{{ item.ResourceTotal }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="hot-rank-mask">
                        <div class="block-header block-header2">
                            <h5 v-if="resourceType=='magazine'" :style="{color:articleorrankindex==0?'#FF9600':'black','border-bottom':articleorrankindex==0?'2px solid #FF9600':'2px solid transparent'}" @click="changerank(0)">
                                {{ langTransfer('推荐阅读') }}
                            </h5>
                            <h5  :style="{color:articleorrankindex==1?'#FF9600':'black','border-bottom':articleorrankindex==1?'2px solid #FF9600':'2px solid transparent'}"  @click="changerank(1)">
                                {{ langTransfer('热门排行') }}
                            </h5>
                            <span/>
                        </div>
                        <div class="rank-list">
                            <template v-if="resourceType === 'audio' || resourceType === 'video'">
                                <div v-for="(item,index) in rankData"
                                     :key="index"
                                     class="rank-item">
                                    <i class="rank-index">{{ index+1 }}</i>
                                    <img :src="item.__cover"
                                         @click="goDetail(item)">
                                    <div class="rank-item-infos"
                                         @click="goDetail(item)">
                                        <p class="rank-name">{{ item.Name }}</p>
                                        <span class="rank-yearIssue" :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="articleorrankindex==1 || resourceType != 'magazine'">
                                    <div  v-for="(item,index) in rankData"
                                         :key="index"
                                         class="rank-item">
                                            <i class="rank-index">{{ index+1 }}</i>
                                            <template v-if="index === 0">
                                                <img :src="item.__cover"
                                                     @click="goDetail(item)">
                                                <div class="rank-item-infos"
                                                     @click="goDetail(item)">
                                                    <p class="rank-name">{{ item.Name }}</p>
                                                    <span class="rank-yearIssue">{{ item.__midInfo }}</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="rank-name"
                                                   @click="goDetail(item)">
                                                    {{ item.Name }}
                                                </p>
                                                <span class="rank-yearIssue"
                                                      @click="goDetail(item)">
                                                    {{ item.__midInfo }}
                                                </span>
                                            </template>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-for="(item,index) in recArticlsData"
                                          class="rank-item rank-item2" @click="goArticleReading(item)">
                                        <i class="rank-index">{{ index+1 }}</i>
                                        <p class="rank-name">
                                            {{ item.ArticleTitle }}
                                        </p>
                                        <span class="rank-yearIssue">
                                            {{ item.Date.split('T')[0].slice(5) }}
                                        </span>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="recommend-right-mask">
                    <div class="recommend-banner">
                        <div ref="bannerWrapper" class="banner-wrapper">
                            <div class="banner-content">
                                <img v-for="(item,index) in bannerData"
                                     :key="index"
                                     :src="item.imgSrc"
                                     @click="bannerItemClick(item.value)">
                            </div>
                        </div>
                        <div v-show="bannerData.length > 0" class="banner-dots">
                            <span v-for="(item, index) in bannerData"
                                  :style="{background: activedBannerIndex === index ? themeColor : ''}"
                                  :key="index"
                                  class="dot" />
                        </div>
                        <div class="banner-actives">
                            <img style="transform: rotateY(180deg)"
                                 src="@/assets/homeRecommend/right-arrow.png"
                                 class="prev"
                                 @click="changeBanner('prev')">
                            <img src="@/assets/homeRecommend/right-arrow.png"
                                 class="next"
                                 @click="changeBanner('next')">
                        </div>
                    </div>
                    <div class="recommend-navs">
                        <img v-for="(item,index) in recommendNavs"
                             :key="index"
                             :src="item.imgUrl"
                             @click="recNavClick(item)">
                    </div>
                  <!--   <div class="recommend-article-daily" v-if="resourceType=='Amagazine'">
                        <div class="recommend-daily-header">
                            <img src="@/assets/homeRecommend/recommendDaily.png">
                            <h5>
                                {{ langTransfer('每日文章') }}
                            </h5>
                        </div>
                        <div class="recommend-daily-body recommend-article-daily-body">
                            <div v-for="(item,index) in recArticlsData" @click="goArticleReading(item)">
                                <div>
                                    <div>{{index+1}}.{{item.ArticleTitle}}</div>
                                    <div>{{item.Date.split('T')[0]}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="recommend-daily">
                        <div class="recommend-daily-header">
                            <img src="@/assets/homeRecommend/recommendDaily.png">
                            <h5>
                                {{ langTransfer('今日推荐') }}
                            </h5>
                        </div>
                        <div class="recommend-daily-body">
                            <template v-if="resourceType === 'audio' || resourceType === 'video'">
                                <div v-for="(item,index) in recData"
                                     :key="index"
                                     class="resource-item">
                                    <img :src="item.__cover"
                                         class="resource-cover"
                                         @click="goDetail(item)">
                                    <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                                    <span @click="goDetail(item)" :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                                    <div class="play-icon" @click="goDetail(item)"/>
                                </div>
                                <div style="height: 0;" class="resource-item"/>
                                <div style="height: 0;" class="resource-item"/>
                                <div style="height: 0;" class="resource-item"/>
                            </template>
                            <template v-else>
                                <div v-for="(item,index) in recData"
                                     :key="index"
                                     class="resource-item">
                                    <img :src="item.__cover" class="resource-cover" v-if="resourceType === 'magazine' && item.CoverImages" :src2="item.CoverImages[2]" @error="$tools.nocover" @click="goDetail(item)">
                                    <img :src="item.__cover"
                                         class="resource-cover"
                                         @click="goDetail(item)" v-else>
                                    <div class="resource-infos">
                                        <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                                        <span @click="goDetail(item)">{{ item.__midInfo }}</span>
                                        <p @click="goDetail(item)" v-html="item.__bottomInfo"></p>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="new-releases-mask">
                <div class="recommend-daily-header">
                    <img src="@/assets/homeRecommend/newRelIcon.png">
                    <h5>
                        {{ langTransfer('最新上架') }}
                    </h5>
                </div>
                <div class="new-releases-body">
                    <template v-if="resourceType === 'audio' || resourceType === 'video'">
                        <div v-for="(item,index) in latestData"
                             :key="index"
                             class="releases-item">
                            <img :src="item.__cover"
                                 class="releases-cover"
                                 @click="goDetail(item)">
                            <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                            <span @click="goDetail(item)" :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                            <div class="play-icon" @click="goDetail(item)"/>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(item,index) in latestData"
                             :key="index"
                             class="resource-item">
                            <img :src="item.__cover" class="resource-cover" v-if="resourceType === 'magazine' && item.CoverImages" :src2="item.CoverImages[2]" @error="$tools.nocover" @click="goDetail(item)">
                            <img :src="item.__cover"
                                 class="resource-cover"
                                 @click="goDetail(item)" v-else>
                            <div class="resource-infos">
                                <h5 @click="goDetail(item)">{{ item.Name }}</h5>
                                <span @click="goDetail(item)">{{ item.__midInfo }}</span>
                                <p @click="goDetail(item)">{{ item.__bottomInfo }}</p>
                                <button @click="goDetail(item)">
                                    {{ langTransfer('立即阅读') }}
                                </button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <template v-for="(cate,index) in cates" >
                <template v-if="cate.__resList">
                    <div :key="index"
                         class="cate-list-mask">
                        <div class="cate-list-header">
                            <h5><i :style="{backgroundColor: themeColor}" />{{ cate.CategoryName }}</h5>
                            <p @click="goAllCatesRoute(cate)">
                                {{ langTransfer('更多') }}
                            </p>
                        </div>
                        <div class="cate-list-body">
                            <template v-if="resourceType === 'audio' || resourceType === 'video'">
                                <div v-for="(item,index) in cate.__resList"
                                     :key="index"
                                     class="cate-list-item">
                                    <img :src="item.__cover"
                                         class="resource-cover"
                                         @click="goDetail(item,cate)">
                                    <h5 @click="goDetail(item,cate)">{{ item.Name }}</h5>
                                    <span @click="goDetail(item,cate)" :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                                    <div class="play-icon" @click="goDetail(item,cate)"/>
                                </div>
                            </template>
                            <template v-else>
                                <div v-for="(item,index) in cate.__resList"
                                     :key="index"
                                     class="cate-list-item">
                                    <img :src="item.__cover" class="resource-cover" v-if="resourceType === 'magazine' && item.CoverImages" :src2="item.CoverImages[2]" @error="$tools.nocover" @click="goDetail(item,cate)">
                                    <img :src="item.__cover"
                                         class="resource-cover"
                                         @click="goDetail(item,cate)" v-else>
                                    <h5 @click="goDetail(item,cate)">{{ item.Name }}</h5>
                                    <span @click="goDetail(item,cate)">{{ item.__midInfo }}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
            <div v-show="showPullUpWarningText"
                 :style="{color: themeColor}"
                 class="pullUp-warning-text">
                {{ langTransfer('加载中...') }}
            </div>
            <div class="site-footer">
                <Footer/>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        props: {
            resourceType: {
                type: String,
                default: undefined
            },
            cates: {
                type: Array,
                default () {
                    return []
                }
            },
            rankData: {
                type: Array,
                default () {
                    return []
                }
            },
            recData: {
                type: Array,
                default () {
                    return []
                }
            },
            latestData: {
                type: Array,
                default () {
                    return []
                }
            },
            pullUpHandler: {
                type: Function,
                default: undefined
            },
            recArticlsData: {
                type: Array,
                default () {
                    return []
                }
            },
        },
        data () {
            return {
                articleorrankindex:0,
                overviewScroll: null,
                resourceNameMap: {
                    magazine: '期刊',
                    book: '图书',
                    audio: '音频',
                    newspaper:'报纸',
                    video:'视频'
                },
                hotMagazine: [
                ],
                bannerSroll: null,
                activedBannerIndex: 0,
                bannerTimer: null,
                recommendNavs: [
                    /* eslint-disable */
                    {
                        imgUrl: require('@/assets/homeRecommend/allCates.png'),
                        routeName: 'allCates',
                        cateCode: 'all'
                    },
                    {
                        imgUrl: require('@/assets/homeRecommend/hotRank.png'),
                        routeName: 'allRank',
                        typeIndex: 0
                    },
                    {
                        imgUrl: require('@/assets/homeRecommend/newReleases.png'),
                        routeName: 'allRank',
                        typeIndex: 2
                    }
                    /* eslint-enable */
                ],
                showPullUpWarningText: false
            }
        },
        computed: {
            isShowResouceCount()
            {
                 return this.$store.state.isShowResouceCount
            },
            resourceCatesClass(){
                const { resourceType } = this
                if (resourceType === 'audio' || resourceType === 'video') 
                {
                    return 'cate-list-av'
                }
                return 'cate-list'
            },
            overviewClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine',
                    'newspaper-likely': resourceType === 'newspaper',
                    'video-likely': resourceType === 'video'
                }
            },
            resourceCates () {
                const { cates, resourceType } = this
                if (resourceType === 'audio' || resourceType === 'video') {
                    return cates;//.slice(0, 7)
                }
                return cates;//.slice(0, 10)
            },
            resourceCatesTotal () {
                let counts=0;
                const { cates, resourceType } = this
                if (resourceType === 'audio' || resourceType === 'video') {
                    cates.forEach((item)=>{
                        counts+=item.ResourceTotal;
                    });
                    return counts+'集';
                }
                cates.forEach((item)=>{
                        counts+=item.ResourceTotal;
                });
                if (resourceType === 'book'){
                    return counts+'本';
                }
                if (resourceType === 'magazine' || resourceType==='newspaper'){
                    return counts+'种';
                }
                
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            bannerData () {
                
                const { bannerData } = this.$store.state;
                const { resourceType } = this;
                let arr = [];
                if (bannerData && bannerData.length > 0){
                    if(resourceType.toLowerCase()=='magazine')
                    {
                        arr = bannerData[0];
                    }   
                    if(resourceType.toLowerCase()=='book')
                    {
                        arr = bannerData[1];
                    }
                    if(resourceType.toLowerCase()=='audio')
                    {
                        arr = bannerData[2];
                    }
                    if(resourceType.toLowerCase()=='video')
                    {
                        arr = bannerData[3];
                    }
                    if(resourceType.toLowerCase()=='newspaper')
                    {
                        arr = bannerData[4];
                    }
                }
                
                if (arr && arr.length > 0) {
                    this.$nextTick(() => {
                        this.initBanner()
                    })
                }
                return arr
            }
        },
        mounted () {
            this.initBScroll()
            this.$nextTick(function () {
                this.$on('refreshBScroll', () => {
                    if (this.overviewScroll) {
                        this.overviewScroll.refresh()
                    }
                })
            })
        },
        methods: {
            changerank(i){
                this.articleorrankindex  = i;
            },
            goArticleReading (item) {
                const params = {
                    resourceType:'magazine',
                    id:item.MagazineId,
                    year:item.Year,
                    issue:item.Issue,
                    articleId: item.ArticleId,
                    token:item.Token
                }

                let routeUrl = this.$router.resolve({
                    name: 'textReading',
                    params
                 });
                debugger
                 window.open(routeUrl.href, '_blank')
                // this.$router.push({
                //     name: 'textReading',
                //     params
                // })
            },
            initBScroll () {
                this.$nextTick(() => {
                    this.overviewScroll = new BScroll(this.$refs.overviewWrapper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 400
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.overviewScroll.on('pullingUp', () => {
                        try {
                            if (typeof this.pullUpHandler === 'function') {
                                this.showPullUpWarningText = true
                                const callBack = () => {
                                    this.overviewScroll.finishPullUp()
                                    this.showPullUpWarningText = false
                                }
                                this.pullUpHandler(callBack)
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            initBanner () {
                this.$nextTick(() => {
                    this.bannerSroll = new BScroll(this.$refs.bannerWrapper, {
                        click: true,
                        bounce: false,
                        scrollX: true,
                        scrollY: false,
                        momentum: false,
                        snap: {
                            loop: true,
                            threshold: 0.3,
                            speed: 1800
                        }
                    })
                    this.bannerSroll.on('scrollEnd', () => {
                        const { pageX } = this.bannerSroll.getCurrentPage()
                        this.activedBannerIndex = pageX
                        this.playBanner()
                    })
                    this.bannerSroll.on('beforeScrollStart', () => {
                        clearTimeout(this.bannerTimer)
                    })
                })
            },
            playBanner () {
                if (this.bannerTimer) {
                    clearTimeout(this.bannerTimer)
                }
                this.bannerTimer = setTimeout(() => {
                    this.bannerSroll.next()
                }, 2000)
            },
            changeBanner (type) {
                if (this.bannerTimer) {
                    clearTimeout(this.bannerTimer)
                }
                if (type === 'next') {
                    this.bannerSroll.next()
                    this.activedBannerIndex += 1
                } else {
                    this.bannerSroll.prev()
                    this.activedBannerIndex -= 1
                }
                if (this.activedBannerIndex < 0) {
                    this.activedBannerIndex = this.bannerData.length - 1
                }
                if (this.activedBannerIndex > this.bannerData.length - 1) {
                    this.activedBannerIndex = 0
                }
            },
            bannerItemClick (httpSrc) {
                if (httpSrc) {
                    window.open(httpSrc, '_blank')
                }
            },
            recNavClick (item) {
                const { resourceType } = this
                const { routeName, cateCode, typeIndex } = item
                const params = {
                    resourceType
                }
                if (typeIndex !== undefined) {
                    params.typeIndex = typeIndex
                }
                if (cateCode !== undefined) {
                    params.cateCode = cateCode
                }
                this.$router.push({
                    name: routeName,
                    params
                })
            },
            goAllCatesRoute (item) {
                const { resourceType } = this
                const params = {
                    resourceType,
                    cateCode: item === 'all' ? item : item.CategoryCode
                }
                this.$router.push({
                    name: 'allCates',
                    params
                })
            },
            goDetail (item, cate) {
                const { resourceType } = this
                this.$tools.goDetailRoute.call(this, resourceType, item, cate)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .resource-overview {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .overview-content {
            width: 1140px;
            margin: 0 auto;
        }

        .recommend-mask {
            width: 100%;
            padding: 20px 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }
    }

    .recommend-left-mask {
        width: 270px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        .total-cates-mask {
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            border-radius: 2px;
        }
        .block-header2 {
            justify-content:start !important;
            h5 {
                margin-right: 1em;
                cursor: pointer !important;
            }
            
        }
        .block-header {
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #F0F2F7;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 50px;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                text-align: right;
                line-height: 50px;
                cursor: pointer;
            }
        }

        .cate-list {
            width: 100%;
            height: 400px;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .cate-list-av {
            //height: 100%;
            width: 100%;
            height: 310px;
            overflow-x: hidden;
            overflow-y: auto;
        }

        .cate-item {
            width: 100%;
            height: 40px;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            p {
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 40px;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                text-align: right;
                line-height: 40px;
            }
        }

        .cate-item:hover {
            background: #F6F6F6;
        }

        .hot-rank-mask {
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            border-radius: 2px;
            overflow: hidden;
        }
    }

    .recommend-right-mask {
        width: 850px;
        height: 100%;
    }

    .recommend-banner {
        width: 850px;
        height: 360px;
        position: relative;

        .banner-wrapper {
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        .banner-content {
            width: fit-content;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            img {
                display: block;
                width: 850px;
                height: 360px;
                cursor: pointer;
            }
        }

        .banner-dots {
            width: 100%;
            height: 42px;
            position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .dot {
                display: block;
                width: 40px;
                height: 2px;
                opacity: 0.8;
                background: #D8D8D8;
                margin-right: 10px;
            }

            .dot:last-child {
                margin-right: 0;
            }
        }

        .banner-actives {

            img {
                width: 20px;
                height: 40px;
                top: 160px;
                cursor: pointer;
            }

            .prev {
                position: absolute;
                left: 10px;
            }

            .next {
                position: absolute;
                right: 10px;
            }
        }
    }

    .recommend-navs {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;

        img {
            width: 270px;
            height: 86px;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            border-radius: 2px;
            cursor: pointer;
        }
    }
    .recommend-article-daily{
        width: 100%;
        margin: 20px 0;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        overflow: hidden;

        .recommend-daily-body {
            width: 100%;
            height: 164px !important;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }
    }

    .recommend-daily {
        width: 100%;
        margin: 20px 0;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        overflow: hidden;

        .recommend-daily-body {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }
    }

    .recommend-daily-header {
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        img {
            width: 17px;
            height: 19px;
            margin: 0 9px 0 18px;
        }

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
        }
    }

    .new-releases-mask {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .new-releases-body {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .cate-list-mask {
        width: 100%;
        margin-top: 20px;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        overflow: hidden;
    }

    .cate-list-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding: 0 34px 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            i {
                display: block;
                width: 4px;
                height: 16px;
                background: #FF5840;
                border-radius: 2px;
                margin-right: 8px;
            }
        }

        p {
            width: 42px;
            
            font-size: 14px;
            color: #8590A6;
            line-height: 50px;
            background-image: url("../assets/homeRecommend/right-arrow.png");
            background-repeat: no-repeat;
            background-position: right center;
            background-size: 6px 12px;
            cursor: pointer;
        }
    }

    .magazine-likely, .book-likely, .newspaper-likely {

        .recommend-mask {
            height: 1012px;
        }

        .total-cates-mask {
            height: 466px;
        }

        .cate-list {
            padding: 8px 0;
        }

        .hot-rank-mask {
            height: 526px;
        }

        .rank-list {
            width: 100%;
            height: 100%;
            padding: 8px 0;
        }

        .rank-item {
            width: 100%;
            height: 40px;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            .rank-index {
                
                font-size: 14px;
                color: #FF9600;
                line-height: 40px;
                width: 24px;
                font-style: normal;
            }

            .rank-name {
                width: 133px;
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .rank-yearIssue {
                width: 80px;
                
                font-size: 14px;
                color: #8590A6;
                text-align: right;
                line-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .rank-item:first-child {
            height: 100px;

            .rank-name {
                width: 133px;
            }

            img {
                width: 66px;
                height: 84px;
                margin-right: 16px;
            }
        }
        .rank-item2{
            height: 42px !important;
            .rank-yearIssue {
                width:46px !important;
            }
            .rank-name {
                width: 160px !important;
            }
        }
        .rank-item2:first-child {
             height: 42px !important;
        }
        .rank-item-infos {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .rank-name {
                line-height: 14px;
                margin-bottom: 8px;
            }

            .rank-yearIssue {
                text-align: left;
                line-height: 14px;
            }
        }

        .rank-item:hover {
            background: #F6F6F6;
        }

        .recommend-daily {
            height: 526px;
        }

        .recommend-daily-body {
            height: 476px;
            box-sizing: border-box;
            padding: 0 34px 32px;
        }

        .resource-item {
            width: 372px;
            height: 190px;
            margin-top: 32px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }

        .resource-cover {
            width: 150px;
            height: 190px;
            border-radius: 4px;
            cursor: pointer;
            background: #f6f6f6;
        }

        .resource-infos {
            width: 208px;
            height: 190px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                cursor: pointer;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                margin: 16px 0 16px;
                cursor: pointer;
            }

            p {
                
                font-size: 14px;
                color: #79808B;
                letter-spacing: 0;
                text-align: justify;
                line-height: 20px;
                max-height: 60px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                margin-top: 22px;
                cursor: pointer;
                position: absolute;
                left: 0;
                bottom: 0;
            }

            button {
                width: 68px;
                height: 20px;
                border-radius: 2px;
                
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 14px;
                cursor: pointer;
            }
        }

        .new-releases-mask {
            height: 304px;
            overflow: hidden;
        }

        .new-releases-body {
            height: 254px;
            padding: 32px 34px;

            .resource-item {
                width: 334px;
                margin-top: 0;
            }

            .resource-infos {
                width: 168px;

                span {
                    margin: 8px 0 16px;
                }

                p {
                    margin-top: 0;
                    margin-bottom: 50px;
                    height: 80px;
                    -webkit-line-clamp: 4;
                    position: static;
                    height: 60px;
                    overflow : hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                button {
                    width: 75px;
                    background: none;
                    
                    font-size: 14px;
                    color: #484E58;
                    letter-spacing: 0;
                    text-align: justify;
                    line-height: 20px;
                    background-image: url("../assets/homeRecommend/right-arrow.png");
                    background-repeat: no-repeat;
                    background-position: right center;
                    background-size: 8px 14px;
                }
            }
        }

        .cate-list-mask {
            height: 330px;
        }

        .cate-list-body {
            width: 100%;
            height: 280px;
            box-sizing: border-box;
            padding: 16px 34px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .cate-list-item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                cursor: pointer;
                margin: 14px 0 8px;
                max-width: 150px;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .audio-likely,.video-likely {

        .recommend-mask {
            height: 1038px;
        }

        .total-cates-mask {
            height: 360px;
        }

        .cate-list {
            padding: 12px 0 18px;
        }

        .hot-rank-mask {
            height: 658px;
        }

        .rank-list {
            width: 100%;
            height: 100%;
            padding: 8px 0;
        }

        .rank-item {
            width: 100%;
            height: 74px;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            img {
                width: 50px;
                height: 50px;
                margin: 0 16px;
            }

            .rank-index {
                
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                width: 20px;
                height: 20px;
                box-sizing: border-box;
                padding-left: 5px;
                font-style: normal;
                background-image: url("../assets/homeRecommend/rankOther.png");
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 20px 20px;
            }
        }

        .rank-item:nth-child(1) {
            .rank-index {
                background-image: url("../assets/homeRecommend/rankOne.png");
            }
        }

        .rank-item:nth-child(2) {
            .rank-index {
                background-image: url("../assets/homeRecommend/rankTwo.png");
            }
        }

        .rank-item:nth-child(3) {
            .rank-index {
                background-image: url("../assets/homeRecommend/rankThree.png");
            }
        }

        .rank-item-infos {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            .rank-name {
                width: 133px;
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 14px;
                margin-bottom: 8px;
                height: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .rank-yearIssue {
                width: 80px;
                
                font-size: 14px;
                color: #8590A6;
                text-align: left;
                line-height: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .rank-item:hover {
            background: #F6F6F6;
        }

        .recommend-daily {
            height: 552px;
        }

        .recommend-daily-body {
            height: 502px;
            box-sizing: border-box;
            padding: 6px 0 6px 34px;
        }

        .resource-item {
            width: 150px;
            height: 208px;
            margin: 19px 34px 19px 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;

            .resource-cover {
                width: 150px;
                height: 150px;
                border-radius: 4px;
                cursor: pointer;
                background: #f6f6f6;
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                cursor: pointer;
                margin: 14px 0 8px;
            }

            span {
                display: block;
                max-width: 150px;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .play-icon {
            cursor: pointer;
            opacity: 0;
            transition: opacity .3s;
            position: absolute;
            left: 0;
            top: 0;
            width: 150px;
            height: 150px;
            background-image: url("../assets/homeRecommend/bgPlayIcon.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-color: rgba(26,26,26,0.20);
        }

        .resource-item:hover {

            .play-icon {
                opacity: 1;
            }
        }

        .new-releases-mask {
            height: 304px;
        }

        .new-releases-body {
            height: 254px;
            padding: 32px 34px;
        }

        .releases-item {
            width:180px;
            margin-top: 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;
            background-image: url("../assets/homeRecommend/audioCoverBg.png");
            background-repeat: no-repeat;
            background-position: 18px -10px;

            .releases-cover {
                width: 150px;
                height: 150px;
                background: #f6f6f6;
                box-shadow: 0 2px 8px 0 rgba(0,0,0,0.50);
                border-radius: 2px;
                cursor: pointer;
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                margin: 14px 0 8px;
                cursor: pointer;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
            }
        }

        .releases-item:hover {

            .play-icon {
                opacity: 1;
            }
        }

        .cate-list-mask {
            height: 330px;
        }

        .cate-list-body {
            width: 100%;
            height: 250px;
            box-sizing: border-box;
            padding: 20px 34px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .cate-list-item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;

            .resource-cover {
                width: 150px;
                height: 150px;
                border-radius: 2px;
                cursor: pointer;
                background: #f6f6f6;
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                cursor: pointer;
                margin: 14px 0 8px;
                max-width: 150px;
            }

            span {
                display: block;
                max-width: 150px;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .cate-list-item:hover {

            .play-icon {
                opacity: 1;
            }
        }
    }

    .resource-cover {
        box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
        background: #f6f6f6;
    }

    .pullUp-warning-text {
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: rgb(0, 132, 255);
    }

    .site-footer {
        padding-bottom: 20px;
    }

    .recommend-article-daily-body{
        padding:10px 34px !important;
        font-size: 14px;
        overflow: auto;
        div{
            
            align-content: space-between;
            width: 100%;
            cursor: pointer;

            div{
                height: 30px;
                line-height:30px;
                display: flex;
                flex-wrap:nowrap;

                justify-content: space-between;
                &>div:first-child{
                    display: unset;
                    width: 670px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                &>div:first-child:hover{
                    text-decoration: underline;
                }
                &>div:last-child{
                    width: 100px;
                }
            }

        }
    }
</style>
